import { get, set } from 'core/classes/helpers/StorageHelper'

const MDF_ACTIVITIES_STORAGE_KEY_PREFIX = '_hp_persist_'

interface IMdfActivitiesSyncTimeParams {
  partnerId: string
  fYear: number
}

interface ISetMdfActivitiesSyncTimeParams extends IMdfActivitiesSyncTimeParams {
  syncTime: number
}

const getMdfActivitiesSyncTimeKey = ({ partnerId, fYear }: IMdfActivitiesSyncTimeParams) => {
  const normalizedPartnerId = encodeURIComponent(partnerId.trim().toUpperCase())

  return `${MDF_ACTIVITIES_STORAGE_KEY_PREFIX}partner360_mdf_activities_last_sync_${normalizedPartnerId}_${fYear}`
}

export const getMdfActivitiesLastSyncTime = (params: IMdfActivitiesSyncTimeParams) => {
  const storedValue = get(getMdfActivitiesSyncTimeKey(params))
  const syncTime = Number(storedValue)

  return storedValue !== null && Number.isFinite(syncTime) && syncTime > 0 ? syncTime : null
}

export const setMdfActivitiesLastSyncTime = ({
  syncTime,
  ...params
}: ISetMdfActivitiesSyncTimeParams) => {
  set(getMdfActivitiesSyncTimeKey(params), String(syncTime))
}
